import {DeepLinkActionBase} from '../deep-link-action-base';

export class LoginDeepLinkAction extends DeepLinkActionBase {
  async execute() {
    await this.services.user.openLogin({}, this.descriptor.marketingParams);
    await this._executeNextAction();
  }
}
